import { Link } from 'react-router-dom';
import { ColumnProps } from '../../types';
import { RenderCellContent } from '../index';
import { Toasts } from 'view/components/Toasts';

export const Column = ({
  cell,
  columnVisibility,
  flexRender,
  hoverEffect,
  programId,
  rowData,
}: ColumnProps) => {
  const columnId = cell.column.id;
  const isVisible = columnVisibility[columnId] ?? true;
  const isColumnVisible = isVisible && cell.column.columnDef !== undefined;
  const showNoAccessToast = () =>
    Toasts.error(
      "You don’t have access to the page you’re trying to view. For more information, contact a system administrator."
    );

  if (isColumnVisible && cell.column.columnDef.id !== 'select') {
    const canNavigate = rowData?.original?.hasAccess ?? true;
    return (
      <td key={cell.id} className={`px-4 ${hoverEffect}`}>
        {cell.column.columnDef?.id === "protocolName" ?
          canNavigate ? (
            <Link
              to={`/protocols/${rowData?.original?.protocolName?.id}/profile`}
              className="cursor-pointer"
            >
              <RenderCellContent
                columnDef={cell.column.columnDef}
                cellValue={cell.getValue()}
                programId={programId}
              />
            </Link>
          ) : (
            <div className="cursor-default" onClick={showNoAccessToast}>
              <RenderCellContent
                columnDef={cell.column.columnDef}
                cellValue={cell.getValue()}
                programId={programId}
              />
            </div>
          )
          :
          <RenderCellContent
            columnDef={cell.column.columnDef}
            cellValue={cell.getValue()}
            programId={programId}
          />}
      </td>
    );
  } else {
    return (
      <td
        key={cell.id}
        className={`sticky left-0 z-10 bg-bgWhite dark:bg-secondaryLight ${hoverEffect}`}
      >
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </td>
    );
  }
};
